import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';

export default function ProactiveGreeting({ isVisible, message, onClick }) {
  if (!isVisible) {
    return null;
  }
  return (
    <ButtonWrapper tabIndex="0">
      <StyledGreetingMessage onClick={onClick} tabIndex="-1">
        {message}
      </StyledGreetingMessage>
    </ButtonWrapper>
  );
}

ProactiveGreeting.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  message: PropTypes.string,
};

const ButtonWrapper = overrideStyle('div')`
  background: none;
  border: none;
  border-radius: 8px;
  box-shadow: none;
  cursor: pointer;
  margin: 0 0 8px 0;
  outline: none;
  padding: 0;
  &:focus {
    box-shadow: 0 0 0px 3px #81b5ea;
    border: 1px #81b5ea;
    outline: none;
  }
  &:active {
    box-shadow: none;
    outline: none;
  }
`;

export const StyledGreetingMessage = overrideStyle('div')`
  background: #f3f3f3;
  border: none;
  box-shadow: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 14px;
  margin: 0;
  outline: none;
  padding: 16px;
  text-align: center;
  user-select: none; 

  @media only screen and (max-device-width: 667px), screen and (max-width: 599px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`;
